<div class="form-modal">
  <div class="modal-title form-divider-title headline-medium">{{ title }}</div>
  <div class="modal-subtitle">{{ subtitle }}</div>
  <ion-searchbar (ionInput)="onSearch($event)" [value]="search" class="measure-search" debounce="200"></ion-searchbar>
  <ion-list class="measure-list" lines="none">
    <ng-container *ngFor="let measure of visibleMeasures">
      <ion-item (click)="onMeasureClick(measure)" [button]="true" class="measure" detail="false">
        <!-- icons, not ion-checkbox: an item forwards its click to a checkbox, which would toggle twice -->
        <ion-icon *ngIf="measure.single" [name]="measure.treatments[0].checked ? 'checkbox' : 'square-outline'" slot="start"></ion-icon>
        <ion-icon *ngIf="!measure.single" [name]="measure.expanded ? 'chevron-down' : 'chevron-forward'" slot="start"></ion-icon>
        <ion-label class="ion-text-wrap">
          <div class="measure-name">{{ measure.label }}</div>
          <div *ngIf="measure.summary" class="measure-summary">{{ measure.summary }}</div>
        </ion-label>
      </ion-item>
      <div *ngIf="measure.expanded" class="treatments">
        <ion-item (click)="toggle(measure, treatment)" *ngFor="let treatment of measure.treatments" [button]="true" class="treatment" detail="false">
          <ion-icon [name]="treatment.checked ? 'checkbox' : 'square-outline'" slot="start"></ion-icon>
          <ion-label>{{ treatment.label }}</ion-label>
        </ion-item>
      </div>
    </ng-container>
  </ion-list>
  <div class="btn-group">
    <ion-button (click)="close()" class="page-button" color="light">{{ "SHARED.Cancel" | translate }}</ion-button>
    <ion-button (click)="apply()" [disabled]="!hasSelection" class="page-button apply-btn" color="secondary">{{ "SHARED.Apply" | translate }}</ion-button>
  </div>
</div>
